import clsx from 'clsx';
import { ActivityLogItem } from 'components/UI/V3/ActivityLog/ActivityLogItem';
import styles from 'components/UI/V3/ActivityLog/ActivityLog.module.scss';
import React from 'react';
import { ActivityLogEntry } from './types';

interface ActivityLogProps {
    title?: string;
    entries: ActivityLogEntry[];
    className?: string;
    maxHeight?: number;
}

export const ActivityLog: React.FC<ActivityLogProps> = ({ title = 'Activity Log', entries, className, maxHeight }) => {
    const containerStyle = maxHeight ? { maxHeight: `${maxHeight}px`, overflowY: 'auto' as const } : undefined;

    return (
        <div className={clsx(styles.root, className)}>
            {title && <h3 className={styles.title}>{title}</h3>}
            <div
                className={styles.list}
                style={containerStyle}
            >
                {entries.map((entry, index) => (
                    <ActivityLogItem
                        key={entry.id}
                        message={entry.message}
                        date={entry.date}
                        status={entry.status}
                        icon={entry.icon}
                        onClick={entry.onClick}
                        isLast={index === entries.length - 1}
                    />
                ))}
            </div>
        </div>
    );
};
